import Axios from '../utils/axiosInstance'

const createOTP = (phoneNumber: string) => {
    return Axios.post('createOtp', { phoneNumber, login_source: 'web' });
}

const createEmailOTP = (email: string) => {
    return Axios.post('sendEmailOtp', {email, login_source: 'web'})
}

const verifyOTP = (data: any) => {
    return Axios.post('verfiyOtp', data)
}

const verifyEmailOTP = (data: any) => {
    return Axios.post('verifyEmailOtp', data)
}

const profileSetup = (data: any) => {
      return Axios.post('profileSetup-web', data)
}

const updateUserDetails = (data: any) => {
    return Axios.put('updateUserDetailsWeb', data)
}


const updateUserDetailsVisibity = (data: any) => {
    return Axios.put('updateUserDetails', data)
}



const updatePreferences = (data: any) => {
    return Axios.put('updatePreferences', data)
}

const loginWeb = (data: any) => {
    return Axios.post('login-web', data);
}
const updatePhoneNumber = (data: any) => {
    return Axios.post('UpdatePhoneNumberByID', data);
    
}
const logout = () => {
    localStorage.clear();
}

const logoutSession = (data?: any) => {
    return Axios.get('logout', data);
    
}


export const AuthService = {
    createOTP,
    createEmailOTP,
    verifyOTP,
    verifyEmailOTP,
    profileSetup,
    updateUserDetails,
    loginWeb,
    logout,
    updatePhoneNumber,
    logoutSession,
    updateUserDetailsVisibity,
    updatePreferences
}